import axios from "axios";

export default function DocumenttemplateShowService(id) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/document-template/" + id,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
